import Moment from 'moment';

export const initDataTypes = (): void => {

    //same format to API
    Date.prototype.toJSON = function () { return Moment(this).format(); }

    Moment.fn.toJSON = function () { return Moment(this).format(); } 
}